// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles__radio__23eeB","radio-text":"styles__radio-text__1dbUj","radioText":"styles__radio-text__1dbUj"};